import React, { useEffect, useCallback, useState } from 'react';
import ReactSlick from 'react-slick';
import useVisibility from 'hooks/useVisibility';
import { useTheme } from '@mui/material/styles';
import NextArrow from './components/NextArrow';
import PrevArrow from './components/PrevArrow';
import { useStyles } from './styles';
import { defaultSettings } from './settings';

const Slider = (props: any) => {
	const { settings = {}, children } = props;

	const { classes } = useStyles();
	const theme = useTheme();

	const sliderSettings = {
		...defaultSettings,
		...settings,
		nextArrow: <NextArrow />,
		prevArrow: <PrevArrow />,
	};

	const wideScreen = window.outerWidth >= theme.breakpoints.values.lg;
	const disableLearn = props.disableLearn || wideScreen;

	const [autoSwiped, setAutoSwiped] = useState<boolean>(disableLearn);

	const slick = React.useRef<Element>(null);
	const animateSlider = useCallback(() => {
		if (slick && slick.current) {
			window.requestAnimationFrame(() => {
				window.requestAnimationFrame(() => {
					// @ts-ignore: Possibly undefined
					slick.current.slickGoTo(0);
				});
			});
		}
	}, [slick]);

	const [isVisible, currentElement] = useVisibility<HTMLDivElement>(0, 1000);
	useEffect(() => {
		if (autoSwiped && !isVisible) {
			return;
		}
		setTimeout(animateSlider, 0);
		setAutoSwiped(true);
	}, [isVisible]);

	return disableLearn ? (
		<ReactSlick
			// @ts-ignore: Possibly undefined
			ref={slick}
			initialSlide={0}
			{...sliderSettings}
			className={classes.slider}
		>
			{children}
		</ReactSlick>
	) : (
		<div ref={currentElement}>
			<ReactSlick
				// @ts-ignore: Possibly undefined
				ref={slick}
				initialSlide={1}
				{...sliderSettings}
				className={classes.slider}
			>
				{children}
			</ReactSlick>
		</div>
	);
};

export default Slider;
